import { Component, OnInit } from '@angular/core';
import { Category, CategoryModelServer } from 'src/app/models/category.model';
import { CategoryService } from 'src/app/services/category.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public category: Category;
      categories: any[] = [];
      categoryId: number;
      categoryName: string;


  constructor(private categoryService: CategoryService
  ) { }

  ngOnInit(): void {

    this.categoryService.getAllCategories().subscribe((data: any[]) => {
      this.categories = data.slice(0,5);
    });

  }


   // Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
    getSlug(name: string): string {
        return name.toLowerCase().replace(/\s+/g, '-');
    }


}

